// extracted by mini-css-extract-plugin
export var required = "_eg-0";